/* BEDRA product page v2 (22.10.2026) – gallery, options, size finder, reviews, mobile bar */
(function () {
  'use strict';
  var UPS_B = [86, 90, 94, 98, 102, 106], UPS_W = [66, 70, 74, 78, 82, 86], SZ = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
  function idx(v, ups) { for (var i = 0; i < ups.length; i++) { if (v < ups[i]) return i; if (v === ups[i]) return Math.min(i + 1, ups.length - 1); } return ups.length; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function initGallery(root) {
    var slides = $$('.bp-slide', root), thumbs = $$('.bp-thumb', root), stage = $('.bp-stage', root);
    if (!slides.length) return;
    var cur = 0;
    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === cur; s.classList.toggle('is-on', on); s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (!on) { var v = s.querySelector('video'); if (v) v.pause(); }
        if (on) { var im = s.querySelector('img[data-src]'); if (im) { im.src = im.getAttribute('data-src'); if (im.getAttribute('data-srcset')) im.srcset = im.getAttribute('data-srcset'); im.removeAttribute('data-src'); } }
      });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === cur); t.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      var t = thumbs[cur]; if (t && t.parentNode) { var p = t.parentNode; if (p.scrollWidth > p.clientWidth) p.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' }); else if (p.scrollHeight > p.clientHeight) p.scrollTo({ top: t.offsetTop - 10, behavior: 'smooth' }); }
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var pv = $('.bp-arrow--prev', root), nx = $('.bp-arrow--next', root);
    if (pv) pv.addEventListener('click', function () { go(cur - 1); });
    if (nx) nx.addEventListener('click', function () { go(cur + 1); });
    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? cur + 1 : cur - 1); x0 = null; }, { passive: true });
    var lb = $('.bp-lb', root.closest('.bp') || document);
    function openLb(at) {
      if (!lb) return;
      $$('img[data-src]', lb).forEach(function (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); });
      lb.hidden = false; document.documentElement.style.overflow = 'hidden';
      var target = $$('img', lb)[at || 0]; if (target) setTimeout(function () { target.scrollIntoView({ block: 'start' }); }, 30);
      $('.bp-lb__x', lb).focus();
    }
    function closeLb() { lb.hidden = true; document.documentElement.style.overflow = ''; }
    var all = $('.bp-all', root); if (all) all.addEventListener('click', function () { openLb(0); });
    slides.forEach(function (s, k) { var im = s.querySelector('img'); if (im) im.addEventListener('click', function () { openLb(Number(s.getAttribute('data-img-index') || 0)); }); });
    if (lb) {
      $('.bp-lb__x', lb).addEventListener('click', closeLb);
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeLb(); if (lb.hidden && document.activeElement && root.contains(document.activeElement)) { if (e.key === 'ArrowLeft') go(cur - 1); if (e.key === 'ArrowRight') go(cur + 1); } });
    }
  }

  function initProduct(root) {
    var dataEl = $('[data-bp-json]', root); if (!dataEl) return;
    var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var T = D.t, V = D.variants, nOpt = D.options.length;
    var sel = D.selected ? D.selected.slice() : new Array(nOpt).fill(null);
    var idInput = $('[data-bp-id]', root), add = $('[data-bp-add]', root), stock = $('[data-bp-stock]', root), price = $('[data-bp-price]', root);
    var mbar = $('[data-bp-mbar]', root), mbarSub = mbar && $('small', mbar), mbarBtn = mbar && $('button', mbar);
    function findVariant() {
      if (sel.some(function (v) { return v === null; })) return null;
      for (var i = 0; i < V.length; i++) { var ok = true; for (var k = 0; k < nOpt; k++) if (V[i].o[k] !== sel[k]) { ok = false; break; } if (ok) return V[i]; }
      return null;
    }
    function fmt(c) { return (c % 100 === 0) ? D.moneyShort.replace('#', String(c / 100)) : D.moneyShort.replace('#', (c / 100).toFixed(2).replace('.', D.decSep)); }
    function render() {
      $$('[data-bp-opt]', root).forEach(function (b) {
        var k = Number(b.getAttribute('data-bp-opt')), val = b.getAttribute('data-value');
        b.classList.toggle('is-on', sel[k] === val);
        b.setAttribute('aria-pressed', sel[k] === val ? 'true' : 'false');
        // availability for this value given other selections
        var any = V.some(function (v) { if (v.o[k] !== val || !v.a) return false; for (var j = 0; j < nOpt; j++) if (j !== k && sel[j] !== null && v.o[j] !== sel[j]) return false; return true; });
        b.disabled = !any;
        var dot = V.some(function (v) { if (v.o[k] !== val || !v.s) return false; for (var j = 0; j < nOpt; j++) if (j !== k && sel[j] !== null && v.o[j] !== sel[j]) return false; return true; });
        var i = b.querySelector('i'); if (dot && !i) { i = document.createElement('i'); i.setAttribute('aria-hidden', 'true'); b.appendChild(i); } else if (!dot && i) i.remove();
      });
      $$('[data-bp-optname]', root).forEach(function (l) { var k = Number(l.getAttribute('data-bp-optname')); var b = $('b', l); if (b) b.textContent = sel[k] !== null ? sel[k] : (D.options[k].size ? T.choose : '–'); });
      var v = findVariant();
      if (idInput) idInput.value = v ? v.id : '';
      var label, dis = false;
      if (!nOpt) { v = V[0]; }
      if (!v) { label = nOpt ? (D.options.some(function (o) { return o.size; }) ? T.chooseSize : T.chooseOpt) : T.add; dis = false; }
      else if (!v.a) { label = T.soldOut; dis = true; }
      else { label = T.add + ' · ' + fmt(v.p); }
      if (add) { add.textContent = label; add.disabled = dis; add.classList.toggle('is-wait', !v && nOpt > 0); }
      if (price && v) { price.innerHTML = fmt(v.p) + (v.c > v.p ? ' <s>' + fmt(v.c) + '</s>' : ''); }
      if (stock) {
        var span = $('span', stock);
        if (!v) { span.textContent = D.anyStock ? T.pick : T.all; stock.classList.remove('is-in'); }
        else { span.textContent = v.s ? T.inStock : T.mto; stock.classList.toggle('is-in', !!v.s); }
      }
      if (mbarSub) mbarSub.textContent = (v ? fmt(v.p) : fmt(D.minPrice)) + ' · ' + (v ? v.o.filter(Boolean).join(' / ') : T.choose);
      if (mbarBtn) mbarBtn.textContent = v ? (v.a ? T.addShort : T.soldOut) : T.addShort;
      if (v && D.selectedOnce) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {} }
    }
    $$('[data-bp-opt]', root).forEach(function (b) {
      b.addEventListener('click', function () { var k = Number(b.getAttribute('data-bp-opt')); sel[k] = b.getAttribute('data-value'); D.selectedOnce = true; render(); });
    });
    var form = $('form[action*="/cart/add"]', root);
    if (form && add) {
      form.addEventListener('submit', function (e) {
        if (!idInput.value) { e.preventDefault(); e.stopImmediatePropagation(); var g = $('[data-bp-opts]', root); if (g) { g.scrollIntoView({ block: 'center', behavior: 'smooth' }); g.animate && g.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 300 }); } }
      }, true);
    }
    if (mbar && add && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { mbar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(add);
      mbarBtn.addEventListener('click', function () { if (idInput && !idInput.value && nOpt) { var g = $('[data-bp-opts]', root); if (g) g.scrollIntoView({ block: 'center', behavior: 'smooth' }); } else if (add && !add.disabled) add.click(); });
    }
    render();

    // size finder
    var m = $('[data-bp-fitm]', root.closest('.bp') || document);
    if (m) {
      document.body.appendChild(m);
      var opener = null, sizeK = -1;
      D.options.forEach(function (o, k) { if (o.size) sizeK = k; });
      var tpl = $('template[data-bp-guide]', m), box = $('[data-bp-chart]', m), chart = null, G = null;
      if (tpl && box) {
        var t1 = tpl.content.querySelector('table');
        if (t1) { box.appendChild(document.importNode(t1, true)); chart = $('table', box); }
      }
      if (chart) {
        try {
          var rows = Array.prototype.slice.call(chart.rows), head = Array.prototype.map.call(rows[0].cells, function (c) { return c.textContent.trim().toUpperCase(); });
          var rowOf = function (re) { for (var i = 1; i < rows.length; i++) if (re.test(rows[i].cells[0].textContent)) return rows[i]; return null; };
          G = { head: head, rb: rowOf(/bust|brust|poitrine|biust/i), rw: rowOf(/waist|taille|talia/i) };
        } catch (e) { G = null; }
      }
      var inB = $('[data-fit-b]', m), inW = $('[data-fit-w]', m), out = $('[data-fit-size]', m), room = $('[data-fit-room]', m), msg = $('[data-fit-msg]', m), ch = $('[data-fit-choose]', m), cur = -1;
      function calc() {
        var b = parseFloat(String(inB.value).replace(',', '.')), w = parseFloat(String(inW.value).replace(',', '.'));
        if (chart) $$('.bp-hl', chart).forEach(function (c) { c.classList.remove('bp-hl'); });
        if (!isFinite(b) || !isFinite(w)) { out.textContent = '?'; room.textContent = T.fitEnter; msg.textContent = ''; ch.hidden = true; cur = -1; return; }
        var i = Math.max(idx(b, UPS_B), idx(w, UPS_W));
        if (i > 5) { out.textContent = '–'; room.textContent = T.fitOver; msg.textContent = T.fitOverMsg; ch.hidden = true; cur = -1; return; }
        cur = i; var s = SZ[i]; out.textContent = s; ch.textContent = T.fitChoose.replace('[s]', s); ch.hidden = false; room.textContent = ''; msg.textContent = T.fitMsg;
        if (G && G.rb && G.rw) {
          var col = G.head.indexOf(s);
          if (col > 0) {
            var gb = parseFloat(G.rb.cells[col].textContent), gw = parseFloat(G.rw.cells[col].textContent);
            if (isFinite(gb) && isFinite(gw)) room.textContent = T.fitRoom.replace('[s]', s).replace('[b]', gb).replace('[w]', gw).replace('[rb]', Math.round(gb - b)).replace('[rw]', Math.round(gw - w));
            Array.prototype.forEach.call(chart.rows, function (r) { if (r.cells[col]) r.cells[col].classList.add('bp-hl'); });
          }
        }
      }
      function open(e) { opener = e.currentTarget; m.hidden = false; document.documentElement.style.overflow = 'hidden'; calc(); inB.focus(); }
      function close() { m.hidden = true; document.documentElement.style.overflow = ''; if (opener) opener.focus(); }
      $$('[data-bp-fitopen]', root).forEach(function (b) { b.addEventListener('click', open); });
      $('[data-fit-close]', m).addEventListener('click', close);
      m.addEventListener('click', function (e) { if (e.target === m) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) close(); });
      inB.addEventListener('input', calc); inW.addEventListener('input', calc);
      ch.addEventListener('click', function () {
        if (cur >= 0 && sizeK >= 0) { var s = SZ[cur]; var btn = $('[data-bp-opt="' + sizeK + '"][data-value="' + s + '"]', root); if (btn && !btn.disabled) { btn.click(); } }
        close();
      });
    }
  }

  function initReviews(root) {
    var tpl = $('template[data-bp-revs]', root), grid = $('[data-bp-revgrid]', root), sec = $('[data-bp-revsec]', root);
    if (!tpl || !grid || !sec) return;
    var T = JSON.parse($('[data-bp-revt]', root).textContent);
    var revs = Array.prototype.slice.call(tpl.content.querySelectorAll('.jdgm-rev'));
    if (!revs.length) return;
    var html = '';
    revs.slice(0, 3).forEach(function (r) {
      var body = (r.querySelector('.jdgm-rev__body') || {}).textContent || '', title = (r.querySelector('.jdgm-rev__title') || {}).textContent || '';
      body = body.replace(/\s+/g, ' ').trim();
      var m1 = body.match(/^.*?[.!?](\s|$)/);
      var q = (m1 ? m1[0].trim() : body) || title;
      if (q.length > 140) q = q.slice(0, 137).replace(/\s+\S*$/, '') + '…';
      var score = Number((r.querySelector('.jdgm-rev__rating') || { getAttribute: function () { return 5; } }).getAttribute('data-score')) || 5;
      var who = ((r.querySelector('.jdgm-rev__author') || {}).textContent || '').trim();
      var ver = r.getAttribute('data-verified-buyer') === 'true';
      var stars = '★★★★★'.slice(0, Math.round(score)) + '☆☆☆☆☆'.slice(0, 5 - Math.round(score));
      var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      html += '<div class="bp-rev"><b aria-label="' + score + '/5">' + stars + '</b><p>“' + esc(q) + '”</p><span>' + esc(who) + (ver ? ' · ' + esc(T.verified) : '') + '</span></div>';
    });
    grid.innerHTML = html;
    sec.hidden = false;
  }

  function init() {
    $$('[data-bp]').forEach(function (root) {
      var g = $('[data-bp-gal]', root); if (g) initGallery(g);
      initProduct(root);
      initReviews(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
